"use client";

import { type VariantProps } from "class-variance-authority";
import { useCallback } from "react";

import AuthDialog from "@/app/(discover)/components/auth-dialog";
import { formMode } from "@/components/auth/form-mode";
import { Button, buttonVariants } from "@/components/ui/button";
import useSignInDrawer from "@/hooks/use-sign-in-drawer";
import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import { cn } from "@/lib/utils";

interface SignInButtonWrapperProps {
  variant?: VariantProps<typeof buttonVariants>["variant"];
  className?: string;
  label?: string;
  testId?: string;
}

export default function SignInButtonWrapper({
  variant = "ghost",
  className = "text-ink-emphasis hover:text-foreground",
  label = "Sign In",
  testId = authTestIds.SIGN_IN_BUTTON,
}: SignInButtonWrapperProps = {}) {
  const { isOpen, openDrawer, closeDrawer } = useSignInDrawer();

  const handleOpenDialog = useCallback(() => {
    openDrawer("1");
  }, [openDrawer]);

  return (
    <div className="contents">
      <Button
        onClick={handleOpenDialog}
        variant={variant}
        className={cn("h-9 px-3 font-medium cursor-pointer", className)}
        data-testid={testId}
      >
        {label}
      </Button>
      <AuthDialog
        mode={formMode.signin}
        isOpen={isOpen}
        onClose={closeDrawer}
      />
    </div>
  );
}
